{
  "title": "Ops",
  "hangarsSelected": "{{count}} Hangar Selected",
  "hangarsSelected_other": "{{count}} Hangars Selected",
  "queue": {
    "title": "Queue",
    "expand": "Expand queue",
    "collapse": "Collapse queue",
    "sections": {
      "unknownAircraft": "Unknown Aircraft",
      "needsAssignment": "Needs Assignment"
    },
    "empty": {
      "title": "All caught up!",
      "description": "No items need attention"
    },
    "filters": {
      "today": "Today",
      "week": "Week",
      "all": "All",
      "searchPlaceholder": "Search..."
    },
    "actions": {
      "resolve": "Resolve",
      "assign": "Assign",
      "searchAircraft": "Search aircraft",
      "addAircraft": "Add"
    },
    "loadError": "Failed to load queue"
  },
  "hangarPicker": {
    "title": "Select Hangars",
    "description": "Choose which hangars to display in the Ops view",
    "selectAll": "Select All",
    "clearAll": "Clear All",
    "noHangars": "No hangars available",
    "cancel": "Cancel",
    "confirm": "Confirm"
  },
  "noHangars": {
    "title": "No hangars selected",
    "action": "Select Hangars"
  },
  "messages": {
    "aircraftResolved": "Aircraft resolved successfully",
    "aircraftAdded": "Aircraft added successfully",
    "tripAssigned": "Trip assigned to hangar",
    "resolveError": "Failed to resolve aircraft",
    "assignError": "Failed to assign trip",
    "addAircraftError": "Failed to add aircraft"
  }
}
